import React, { useMemo } from 'react'
import styled from 'styled-components'
import { CustomerOrder, GrowerDetail } from '../../../../../modules/API/Seller/models/tableData'
import TableCellInput from './TableCellInput'
import PencilIcon from '../../../../../generic/icons/IconLib/PencilIcon'
import SellerBodyCell, { BalanceState } from './grid/SellerBodyCell'

interface Props extends CustomerOrder {
  index: number,
  Growers: GrowerDetail[],
  handleTopOrderChange: (e: React.ChangeEvent<HTMLInputElement>, customer: number) => void
  handleOpenRemarkModal: (e: React.MouseEvent, growerID: number, customerID: number, freightCompanyID: number, qty: number, remark: string, lineType?: number) => void
}

const SellerBodyBlockElement = ({
  Growers, index, OrderDetail, handleTopOrderChange, Customer, handleOpenRemarkModal
}: Props) => {
  const culcGivenCustomerPalletByGrowers = useMemo(() => {
    return Growers.reduce((acc, cur) => {
      return acc + cur.Customers[index].OrderDetail.Order_Pallets

    }, 0)
  }, [Growers, index])

  const state: BalanceState =
  OrderDetail.Order_Pallets === 0 && culcGivenCustomerPalletByGrowers === 0 ? undefined :
    OrderDetail.Order_Pallets - culcGivenCustomerPalletByGrowers === 0 ? undefined
    : OrderDetail.Order_Pallets - culcGivenCustomerPalletByGrowers < 0 ? 'under'
    : 'over'
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleTopOrderChange(e, Customer.CustomerID)
  }

  return (
    <SellerBodyCell
      state={state}
    >
      <CellContent>
        <TableCellInput
          value={OrderDetail.Order_Pallets}
          onChange={handleChange}
        />
        {
          OrderDetail.RecID !== 0 && (
            <IconBtn
              onClick={(e) => handleOpenRemarkModal(e, 0, Customer.CustomerID, OrderDetail.FreightCompanyID, OrderDetail.Order_Pallets, OrderDetail.Remarks, 1)}
              $marked={OrderDetail.Remarks.trim() !== ""}
            >
              <PencilIcon size={16} />
            </IconBtn>
          )
        }
      </CellContent>
    </SellerBodyCell>
  )
}

const CellContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25em;
`
const IconBtn = styled.span<{ $marked?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme, $marked }) => ($marked ? theme.colors.danger : theme.colors.icon)};
  transition: color ${({ theme }) => theme.motion.fast} ease;
  &:hover {
    color: ${({ theme }) => theme.colors.ink};
  }
`
export default SellerBodyBlockElement
